import { Box } from '@material-ui/core';
import fedshiLogo from '../../assets/fedshi-logo.png';

// Fedshi wordmark. The mark already contains the brand name, so no text label.
const LogoFull = () => {
  return (
    <Box display="flex" alignItems="center">
      <img src={fedshiLogo} alt="Fedshi" style={{ height: 32, width: 'auto' }} />
    </Box>
  );
};

export default LogoFull;
